'use strict'

import {App} from './App'

const app = new App()

const viewSubmit = document.getElementById('js-view-submit')
const submitBtn = document.querySelector('[name="submit"]')

viewSubmit.addEventListener('click', () => {
  submitBtn.click()
})

// debug
// const el = document.querySelector('.contact__heading')
// el.addEventListener('click', () => {
//   document.querySelector('[name=your-sei]').value = 'テスト'
//   document.querySelector('[name=your-mei]').value = 'テスト'
//   document.querySelector('[name=your-sei-kana]').value = 'テスト'
//   document.querySelector('[name=your-mei-kana]').value = 'テスト'
//   document.querySelector('[name=your-email]').value = 'kenta@stylishsound.com'
//   document.querySelector('[name=your-email-confirm]').valu  e = 'kenta@stylishsound.com'
//   document.querySelector('[name=your-adrs]').value = '東京都新宿区123 ビル3F'
//   document.querySelector('[name=your-msg]').value = `テキストテキストテキストテキスト
// テキストテキストテキスト`
// })
